export default __webpack_public_path__ + "static/media/nature2.1e81eb12.png";